/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useEffect, useState } from "react";

import { Dialog, Transition } from "@headlessui/react";

import { ToastContext } from "common/contexts";
import getData from "common/fetch/get";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast/index";
import StepBar from "components/molecules/StepBar/index";

import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";

import Styles from "../Styles.module.scss";

const dataStep = [
  {
    id: 1,
    name: "Assessment",
    sub_step: [],
  },
  {
    id: 2,
    name: "Tax Status",
    sub_step: [],
  },
  {
    id: 3,
    name: "Compliance Requirements",
    sub_step: [],
  },
];

function ScreenQuestion({ setStartScreen, data }) {
  const { questions } = data;
  const [step, setStep] = useState(1);
  const [countries, setCountries] = useState([]);
  const [firstRender, setFirstScreen] = useState(true);
  const [nextStep, setNextStep] = useState();
  const [question, setQuestion] = useState(questions[0]);
  const [step2Result, setStep2Result] = useState();
  const [step3Result, setStep3Result] = useState();
  const [arrayQuestion, setArrQuestion] = useState([]);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const { openAlert, setOpenAlert } = useContext(ToastContext);

  useEffect(() => {
    if (nextStep) {
      if (nextStep == "final") {
        setStep(2);
      } else {
        const current = questions?.find((item) => item.id === nextStep);

        setQuestion(current);
      }
      setArrQuestion([...arrayQuestion, question]);
    }
  }, [nextStep]);

  useEffect(() => {
    if (step) {
      if (step === 2) {
        window.localStorage.setItem("belizeTaxMiniTool", questions);
      }
      if (step === 3) {
        window.localStorage.setItem("belizeTaxMiniTool", questions);
      }
    }
  }, [step]);

  useEffect(() => {
    if (firstRender) {
      const dataStorage = JSON.parse(
        window.localStorage.getItem("belizeTaxMiniTool")
      );

      setFirstScreen(false);
      if (dataStorage) {
        if (dataStorage?.step != "") {
          setStep(dataStorage.step);
        }
        if (dataStorage?.current_question != "") {
          setQuestion(dataStorage.current_question);
        }
        if (dataStorage?.prev_question != "") {
          setArrQuestion(dataStorage.prev_question);
        }
        if (dataStorage?.step2_result != "") {
          setStep2Result(dataStorage.step2_result);
        }
        if (dataStorage?.step3_result != "") {
          setStep3Result(dataStorage.step3_result);
        }
      }
    } else {
      const dataLocal = {
        step: step || "",
        prev_question: arrayQuestion || "",
        current_question: question || "",
        step2_result: step2Result || "",
        step3_result: step3Result || "",
      };

      window.localStorage.setItem(
        "belizeTaxMiniTool",
        JSON.stringify(dataLocal)
      );
    }
  });

  async function fetchCountries() {
    const response = await getData({
      url: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`,
    });

    if (response.data && response.data.length > 0) {
      setCountries(
        response.data.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }))
      );
    }
  }

  useEffect(() => {
    try {
      // Async function fetchCountries() {
      //   Const response = await axios.get(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`
      //   );
      //   If (response.data && response.data.data) {
      //     SetCountries(
      //       Response.data.data.map((item) => ({
      //         ...item,
      //         Label: item.name,
      //         Value: item.id,
      //       }))
      //     );
      //   }
      // }

      fetchCountries();
    } catch (error) {
      console.error();
    }
  }, []);

  const handleBack = () => {
    if (step === 3) {
      setStep(2);
    } else if (step === 2) {
      setStep(1);
      setQuestion(arrayQuestion[arrayQuestion.length - 1]);
      setNextStep(false);
      arrayQuestion.pop();
    } else if (arrayQuestion.length > 0) {
      setQuestion(arrayQuestion[arrayQuestion.length - 1]);
      setNextStep(false);
      arrayQuestion.pop();
    }
  };

  const handleReset = () => {
    localStorage.removeItem("belizeTaxMiniTool");
    setStartScreen(true);
  };

  const onResetClick = () => {
    openAlert(false, "custom", {
      bgAlert: "bg-white",
      element: (
        <>
          <Img
            src="/assets/icons/warning.png"
            width={98}
            height={100}
            alt="icon error"
            className="mx-auto mb-6"
            wrapper={{
              className: "block",
            }}
          />
          <p className="mb-6 text-2xl font-semibold text-bbc-brand-700">
            Are you sure?{" "}
          </p>
          <div className="flex justify-around">
            <ButtonNew
              variant="outline"
              btnTextColor={"text-bbc-red-300 hover:text-white"}
              btnBorder={"border border-bbc-red-300 hover:border-bbc-red-400"}
              btnColor={"bg-transparent hover:bg-bbc-red-400"}
              othersClass={"w-28"}
              onClick={() => {
                setOpenAlert(false);
              }}
            >
              No
            </ButtonNew>
            <ButtonNew
              othersClass={"w-28"}
              onClick={() => {
                handleReset();
                setOpenAlert(false);
              }}
            >
              Yes
            </ButtonNew>
          </div>
        </>
      ),
    });
  };

  return (
    <div
      className={`${Styles.boxShadowOnlyPC} shadow-b-bbc rounded-xl bg-transparent lg:bg-white`}
    >
      <div className="py-0 px-0 lg:py-10 lg:px-20">
        <div className="mb-2 lg:mb-8">
          <button
            onClick={() => onResetClick()}
            className="font-medium text-bbc-primary"
          >
            Reset
          </button>
        </div>
        <p className="mb-6 text-center text-2xl font-semibold leading-9 text-bbc-brand-700 lg:mb-10 lg:text-bbc-30px">
          Belize
          <br className="inline lg:hidden" /> Tax Status Assessment
        </p>
        <div className="mb-10">
          <StepBar step={step} data={dataStep} />
        </div>
        <div className="mb-6 lg:mb-8">
          {step === 1 ? (
            <Step1
              question={question}
              setNextStep={setNextStep}
              blacklisted={data.blacklisted}
              setStep2Result={setStep2Result}
              setStep3Result={setStep3Result}
              countries={countries}
              prevQuestion={arrayQuestion}
            />
          ) : step === 2 ? (
            <Step2 setStep={setStep} step2Result={step2Result} />
          ) : (
            <Step3 step2Result={step2Result} step3Result={step3Result} />
          )}
        </div>
        <div>
          <button
            onClick={() => handleBack()}
            className={`${
              arrayQuestion && arrayQuestion.length > 0 ? "block" : "hidden"
            } font-medium text-bbc-gray opacity-50`}
            disabled={arrayQuestion.length <= 0}
          >
            Back
          </button>
        </div>
      </div>
      <>
        <Transition appear show={isOpenPopup} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-y-auto"
            onClose={() => setIsOpenPopup(false)}
            style={{ zIndex: 51 }}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-[rgba(0,0,0,.4)]" />
              </Transition.Child>
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="my-8 inline-block w-full max-w-lg transform overflow-hidden rounded-[10px] bg-white px-6 py-10 text-center align-middle shadow-xl transition-all">
                  <Img
                    src="/assets/images/offshore/guide-and-tool/es-tool/warning-es_tool.svg"
                    width={128}
                    height={109}
                    alt="warning"
                  />
                  <Title
                    text="Are you sure?"
                    className="mt-6 text-lg font-medium text-bbc-brand-700 lg:text-2xl lg:font-semibold lg:leading-9"
                  />
                  <div className="mt-6 flex justify-center gap-x-6">
                    <ButtonNew
                      onClick={() => setIsOpenPopup(false)}
                      btnColor={"bg-bbc-neutral-600 hover:bg-bbc-neutral-700"}
                      othersClass=" min-w-[109px] font-medium"
                    >
                      No
                    </ButtonNew>
                    <ButtonNew
                      onClick={() => handleReset()}
                      othersClass="min-w-[109px] font-medium"
                    >
                      Yes
                    </ButtonNew>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </>
    </div>
  );
}

export default function BelizeMiniTool({ setStartScreen, data }) {
  return (
    <Toast>
      <ScreenQuestion setStartScreen={setStartScreen} data={data} />
    </Toast>
  );
}
